import { LikutKabalaSubSQL, LikutPath, LikutSubSQL } from 'src/app/Interfaces/likut';
import { TruckDistributionPath, TruckDistributionSubSQL } from 'src/app/Interfaces/truck-distribution';
import { TruckLoadingPath, TruckLoadingSubSQL } from 'src/app/Interfaces/truck-loading';
import { SubAppModes } from '../likut-clients/likut-clients.component';

export type LineIdentifierOptions = {
	[K in SubAppModes]: {
		mode: K;
		task: K extends TruckDistributionPath
			? TruckDistributionSubSQL
			: K extends TruckLoadingPath
			? TruckLoadingSubSQL
			: K extends LikutPath
			? LikutSubSQL
			: K extends 'likut-mekabel'
			? LikutKabalaSubSQL
			: K extends 'reclamation-rallyance'
			? never
			: never;
	};
}[SubAppModes];

export function getLineIdentifier(options: LineIdentifierOptions): string {
	switch (options.mode) {
		case 'truck-distribution':
		case 'truck-loading':
			const { task: truckTask } = options;
			return `${truckTask.ProductID}-${truckTask.DocNum}-${truckTask.LineNum}`;
		case 'likut':
			const { task: likutTask } = options;
			return `${likutTask.ProductId}-${likutTask.TeudaNum}-${likutTask.TeudaLineNum}`;
		case 'likut-mekabel':
			const { task: likutMekabelTask } = options;
			return `${likutMekabelTask.TeudaNum}-${likutMekabelTask.TeudaLineNum}`;
		case 'reclamation-rallyance':
			return '';
		default:
			return '';
	}
}
